/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Admin_Could_Not_Stop_ImpersonatingInputs */

const en_mobile_admin_could_not_stop_impersonating = /** @type {(inputs: Mobile_Admin_Could_Not_Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not stop impersonating`)
};

const es_mobile_admin_could_not_stop_impersonating = /** @type {(inputs: Mobile_Admin_Could_Not_Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo detener la impersonación`)
};

/**
* | output |
* | --- |
* | "Could not stop impersonating" |
*
* @param {Mobile_Admin_Could_Not_Stop_ImpersonatingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_admin_could_not_stop_impersonating = /** @type {((inputs?: Mobile_Admin_Could_Not_Stop_ImpersonatingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Admin_Could_Not_Stop_ImpersonatingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_admin_could_not_stop_impersonating(inputs)
	return en_mobile_admin_could_not_stop_impersonating(inputs)
});